import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

import {BackToIndustryVerticalsButton} from "../layout/BackButton";
import QuickLinksSection from "../products/QuickLinksSection";
function AgriculturePage({ handleNavClick }) {
  return (
    <div className="industry-detail-page agri-page">
      {/* Back Arrow Button */}
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />

      <div className="agri-header">
        <div className="section__container">
          <h2 className="section__title">Agriculture</h2>
          <p className="section__intro">
            Revolutionizing farming practices with precision agriculture and geospatial technology.
          </p>
        </div>
      </div>

      {/* Agriculture About Section */}
      <section className="agri-about-section">
        <div className="section__container agri-about-container">
          <div className="agri-about-text">
            <h2>Precision Agriculture Solutions</h2>
            <p>
              We provide comprehensive agricultural solutions leveraging advanced GIS technology, satellite imagery, and data analytics to optimize farming practices. Our precision agriculture approach helps farmers make data-driven decisions for improved crop yields, resource management, and sustainable farming practices.
            </p>
          </div>
          <div className="agri-about-image">
            <img src="/agri1.jpg" alt="Agriculture Overview" />
          </div>
        </div>
      </section>

      {/* GEO Tagging Section */}
      <section className="agri-geo-tagging-section">
        <div className="section__container">
          <div className="agri-geo-header">
            <h2>GEO TAGGING OF LAND PARCELS AND LINKING THEM WITH UNIQUE FARMER DATABASE</h2>
          </div>
          <div className="geo-tagging-content">
            <div className="geo-tagging-image">
              <img src="/agri2.png" alt="GEO Tagging Workflow" />
            </div>
            <div className="geo-tagging-features">
              <h3>Farm parcels Digitisation</h3>
              <ul>
                <li>Remove duplicate entries</li>
                <li>Merge records across different tables and databases</li>
                <li>Match the records based on multiple feature columns</li>
                <li>Perform matching operations</li>
                <li>Customized Enterprise Web GIS Application</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Horticulture Information System */}
      <section className="horticulture-section">
        <div className="section__container">
          <div className="horticulture-header">
            <h2>DEVELOPMENT OF HORTICULTURE INFORMATION SYSTEM</h2>
          </div>
          <div className="horticulture-content">
            <div className="horticulture-image">
              <img src="/agri.jpg" alt="Horticulture Information System" />
            </div>
          </div>
        </div>
      </section>
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'information-technology' ,title: 'Information Technology', icon: '/bgs/IT_bg.png' },
          { id: 'gis-services', title: 'GIS and Data Services',icon:'/bgs/GIS.png' },
          { id: 'environment', title: 'Environment',icon:'/bgs/env.png' },
          { id: 'health', title: 'Health',icon:'/bgs/health.png' },
          { id: 'education-research', title: 'Education & Research',icon:'/bgs/edu.png' }
        ]}
      />
    </div>
  )
}


// Agriculture

function AgricultureFeatureSection({ title, text, imgSrc, imgAlt, reverse }) {
  return (
    <section className={`agri-feature-section${reverse ? ' reverse' : ''}`}>
      <div className="section__container agri-feature-container">
        <div className="agri-feature-image">
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className="agri-feature-text">
          {title && <h3>{title}</h3>}
          <p>{text}</p>
        </div>
      </div>
    </section>
  );
}


export default AgriculturePage;